import { TemplateElement, defineElement, html } from '@webtides/element-js';

export default class SlotTrack extends TemplateElement {
    numbers = [];

    properties() {
        return {
            startAnimation: false,
            animateToValue: 0,
            duration: 2000,
            distanceToMove: '',
            rounds: 2,
        };
    }

    connected() {
        this.distanceToMove = this.randomStartPosition();
    }

    randomIntFromInterval(min, max) {
        // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    randomStartPosition() {
        const rnd = this.randomIntFromInterval(0, this.animateToValue - 1);
        const elementToMove = this.$refs?.digits[rnd];
        return elementToMove?.offsetTop;
    }

    watch() {
        return {
            startAnimation: (newValue) => {
                this.$refs.track.classList.add('play-animation');
                // Gets the digit element to animate to.
                const elementToMove = this.$refs?.digits[this.animateToValue + (this.rounds - 1) * 10];
                this.distanceToMove = elementToMove.offsetTop;
            },
        };
    }

    template() {
        this.numbers = Array.from({ length: 10 * this.rounds }, (_, i) => i % 10);
        const digits = this.numbers.map(
            (number) => html`
                <li ref="digits[]">${number}</li>
            `,
        );

        return html`
            <ul
                ref="track"
                class="digits absolute left-0 top-0"
                style="--target: ${this.distanceToMove}px; --duration: ${this.duration}ms;">
                ${digits}
            </ul>
        `;
    }
}
defineElement('slot-track', SlotTrack);
